import { useEmployeesCtx } from '@/components/providers/employee-provider';
import { useOfficeCtx } from '@/components/providers/v1-office-provider';

export function useEmployeeById(id: string | null | undefined) {
  const { employeesById } = useEmployeesCtx();
  if (!id) return null;
  return employeesById.get(id) ?? null;
}

export function useSkillById(id: string | null | undefined) {
  const { skillsById } = useOfficeCtx();
  if (!id) return null;
  return skillsById.get(id) ?? null;
}

export function useRegionById(id: string | null | undefined) {
  const { regionsById } = useOfficeCtx();
  if (!id) return null;
  return regionsById.get(id) ?? null;
}

export function useIssuesById(id: string | null | undefined) {
  const { issuesById } = useOfficeCtx();

  if (!id) return null;
  return issuesById.get(id) ?? null;
}
